import React, {useEffect, useState} from 'react';
import {Button, Card, Col, Container, Form, Image, Modal} from "react-bootstrap";
import {FaRankingStar} from "react-icons/fa6";
import {toast} from "react-toastify";
import {editAssignment} from "../../../http/bookAPI";
import Row from "react-bootstrap/Row";

const SendMessageToReviewer = ({ show, onClose, assign, onUpdateAssign}) => {
    const [loading, setLoading] = useState(false);
    const [ratingOfReviewer, setRatingOfReviewer] = useState(assign?.rating_of_reviewer); // Состояние для хранения рейтинга
    const [commentToReview, setCommentToReview] = useState(""); // Состояние для хранения комментария к отзыву

    useEffect(() => {
        if (assign?.comment_to_review) {
            setCommentToReview(assign?.comment_to_review);
        }
    }, [assign?.comment_to_review]);

   const handleSave = async () => {
        // Если рейтинг меньше 5, обязательно требуется указать причину

        try {
            setLoading(true);
            // Отправляем запрос на обновление задания с новым рейтингом и причиной отмены
            await editAssignment({
                id: assign.id,
                comment_to_review: commentToReview,
            });

            onUpdateAssign?.({ rating_of_reviewer: ratingOfReviewer, comment_to_review: commentToReview }); // 👈 обновляем только нужное поле


            internalOnClose(); // Закрываем модальное окно

        } catch (error) {
            console.error("Error saving rating", error);
            toast.error("Error saving rating", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        } finally {
            setRatingOfReviewer(0);
            setLoading(false);
        }
    };

   const internalOnClose = () => {
       setCommentToReview('')
       onClose();
   };


    return (
        <Modal size="lg" show={show} onHide={onClose} top>
            <div className="modal-content">
                {/* Header */}
                <div className="modal-header small" style={{height:40}}>
                    <h6 className="modal-title fs-6">Send a Message to the Reviewer:</h6>
                   <button type="button" className="btn-close" aria-label="Close" onClick={internalOnClose}></button>
                </div>
                {/* Body */}
                <div className="modal-body p-2 small">
                    <Container>
                        <div className="mb-3">
                            <p className="text-muted" style={{ lineHeight: "1.4", marginBottom: "6px" }}>
                                Here you can write a short and respectful message to the reviewer of your book.
                                Please keep your note <strong>polite</strong>, <strong>constructive</strong>, and
                                focused on the review itself.
                            </p>
                            <p className="text-muted" style={{ lineHeight: "1.4", marginBottom: "6px" }}>
                                You may kindly ask for a clarification, suggest a small correction, or express your appreciation
                                for the time they took to read and review your book.
                            </p>
                        </div>


                        <div className="mx-auto small" style={{ maxWidth: '600px' }}>
                            <Form.Group className="mb-3">
                                <Form.Control
                                    as="textarea"
                                    style={{ fontSize: '0.875rem' }}
                                    className="border border-secondary shadow-sm"
                                    rows={3}
                                    value={commentToReview}
                                    onChange={(e) => setCommentToReview(e.target.value)}
                                    placeholder="Enter Your Message to Reviewer..."
                                />
                            </Form.Group>
                        </div>

                        <div className="mb-3">
                            <p className="text-muted" style={{ lineHeight: "1.4", marginBottom: "6px" }}>
                                Please avoid <strong>personal remarks</strong> or emotional reactions.
                                Our goal is to maintain a positive and professional exchange between authors and reviewers.
                            </p>
                            <p className="text-muted" style={{ lineHeight: "1.4", marginBottom: "0" }}>
                                Thank you for contributing to a respectful and supportive community.
                            </p>
                        </div>



                    </Container>
                </div>
                {/* Footer */}
                <div
                    className="modal-footer d-flex align-items-center justify-content-end px-2"
                    style={{ height: 44, paddingTop: 0, paddingBottom: 0 }}
                >

                    <Button variant="secondary"
                            className="btn btn-sm"
                            onClick={internalOnClose}

                    >
                        Cancel
                    </Button>
                    <Button
                        variant="success"
                        onClick={handleSave}
                        className=" text-white btn-sm d-flex align-items-center"

                        disabled={loading} // ✅ Делаем кнопку неактивной
                    >
                        {loading ? "Saving..." : (<><FaRankingStar className="me-2" /> Submit</>)}
                    </Button>

                </div>
            </div>
        </Modal>
    );
};

export default SendMessageToReviewer;